import FeedVirtualized from '../../components2/Feed/FeedVirtualized';

import {
    fetchHomeFeedPopular,
    HOME_FEED_KEY
} from "../../../api/public-voissa/home-feed";
import { useInfiniteQuery } from '@tanstack/react-query';
import indexSessionStorage from '../../../libs/indexSessionStorage';

const HomeFeedDefaultPopular = ()=>{
    const infiniteQuery = useInfiniteQuery(
        [HOME_FEED_KEY],
        () => fetchHomeFeedPopular({page : indexSessionStorage.get(HOME_FEED_KEY)}),
        {
            staleTime : (60 * 60 * 2),
            getNextPageParam: (lastPage) => {
                const nextPage = lastPage && lastPage.more ? lastPage.page + 1 : null;
                if (nextPage) {
                    indexSessionStorage.set(HOME_FEED_KEY, nextPage, 2);
                }
                return nextPage;
            }
        }
    );
    return (
        <FeedVirtualized
            infiniteQuery={infiniteQuery}
        />
    )
}

export default HomeFeedDefaultPopular;